import Vue from 'vue';
import { onUnmounted, onMounted } from '@vue/composition-api';
import useFocusTrap from '@/hooks/useFocusTrap';
export default Vue.extend({
    name: 'Modal',
    props: {
        width: {
            type: String,
            required: false
        },
        ariaLabelledById: {
            type: String,
            required: true
        },
        ariaDescribedById: {
            type: String,
            required: false
        },
        previousFocusId: {
            type: String,
            required: true
        }
    },
    setup(props, ctx) {
        const { focusTrap } = useFocusTrap(ctx);
        onMounted(() => {
            ctx.refs.modalRef.focus();
        });
        onUnmounted(() => {
            const previousFocusId = props.previousFocusId;
            const previousFocusedElement = document.getElementById(previousFocusId);
            if (previousFocusedElement) {
                previousFocusedElement.focus();
            }
        });
        return {
            focusTrap
        };
    }
});
